<template>
    <div class="card">
        <div class="card-body text-center">

            <div class="card-text">
                <h5 class="card-title text-success">#{{ publicID }}</h5>
                <pre>{{ problem.text }}</pre>
            </div>

            <div v-show="withPIC">
                <img :src="picURL"/>
            </div>

            <div>
                <a @click="$emit('editProblem', publicID)" target="_blank" type="button" class="btn btn-sm btn-outline-danger" v-if="isEditor">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                        <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                    </svg>
                </a>
                <a @click="$emit('openGearModal', problem)" target="_blank" type="button" class="btn btn-sm btn-outline-info">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-info-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                    </svg>
                </a>
                <a @click="$emit('openProblem', publicID)" target="_blank" type="button" class="btn btn-sm btn-outline-success">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-cursor" viewBox="0 0 16 16">
                        <path d="M14.082 2.182a.5.5 0 0 1 .103.557L8.528 15.467a.5.5 0 0 1-.917-.007L5.57 10.694.803 8.652a.5.5 0 0 1-.006-.916l12.728-5.657a.5.5 0 0 1 .556.103zM2.25 8.184l3.897 1.67a.5.5 0 0 1 .262.263l1.67 3.897L12.743 3.52 2.25 8.184z"/>
                    </svg>
                </a>
            </div>

        </div>
    </div>
</template>

<script>

export default {
  name: 'ProblemCard',
  props: {
      publicID: Number,
      problem: Object,
      isEditor: Boolean
  },
  data() {
      return {
          withPIC: false,
          picURL: null
      }
  },
  async mounted() {
      if(this.problem.picNameFile) {
          this.withPIC = true
          this.picURL = await this.storageRef.child(this.problem.picNameFile).getDownloadURL()
      }
  },
  watch: {
      async problem() {
        if(this.problem.picNameFile) {
            this.withPIC = true
            this.picURL = await this.storageRef.child(this.problem.picNameFile).getDownloadURL()
        } else {
            this.withPIC = false
            this.picURL = null
        }
      }
  }
}
</script>

<style scoped>
    pre {
        font-family:    -apple-system, BlinkMacSystemFont, "Segoe UI", Android Roboto, 
                        "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", 
                        sans-serif, "Apple Color Emoji", "Segoe UI Emoji", 
                        "Segoe UI Symbol", "Noto Color Emoji";
        font-size: 16px;  
        white-space: pre-wrap;     
    }
    img {
        margin: 0 0 16px 0;
        max-width: 100px;
    }
    a {
        margin: 0px 2px 0px 2px;
        box-shadow: 0 1px 3px black;
    }
</style>